// @ts-nocheck
import { SplitOrderCartNotesModel } from "@store/Framework/Types/ApiModels";
import {
    UpdateSplitOrderCartNotesAPIParameters,
    updateSplitOrderCartNotesWithResult as updateSplitOrderCartNotesLineApi,
} from "@store/Framework/Services/SplitOrderCartLineService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

interface UpdateSplitOrderCartNotesParameter {
    onSuccess?: () => void;
    splitOrderCartNotes: SplitOrderCartNotesModel;
}

type HandlerType = ApiHandlerDiscreteParameter<
    UpdateSplitOrderCartNotesParameter,
    UpdateSplitOrderCartNotesAPIParameters
>;

export const DispatchBeginUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ReviewAndSubmit/BeginUpdateSplitOrderCartLine",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { splitOrderCartNotes, ...newParameter } = props.parameter;
    props.apiParameter = {
        splitOrderCartNotes,
        ...newParameter,
    };
};

export const UpdateCartNotes: HandlerType = async props => {
    try {
        const result = await updateSplitOrderCartNotesLineApi(props.apiParameter);
        if (!result.successful) {
            props.dispatch({ type: "Greif/Pages/ReviewAndSubmit/FailedToUpdateSplitOrderCartLine" });
            return false;
        }
    } catch (error) {
        props.dispatch({ type: "Greif/Pages/ReviewAndSubmit/FailedToUpdateSplitOrderCartLine" });
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const DispatchCompleteUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ReviewAndSubmit/CompleteUpdateSplitOrderCartLine",
    });
};

export const chain = [
    DispatchBeginUpdateCartLine,
    PopulateApiParameter,
    UpdateCartNotes,
    DispatchCompleteUpdateCartLine,
    ExecuteOnSuccessCallback,
];

const updateSplitOrderCartNotes = createHandlerChainRunner(chain, "UpdateSplitOrderCartLine");
export default updateSplitOrderCartNotes;
